// extracted by css-extract-rspack-plugin
export default {"editorContent":"_hYzO","img":"KNtwF"};